import { ICountryRatesOrganize } from './rateSummary.models';

export const organizeRateSummary: ICountryRatesOrganize = (DataCMS) =>
  DataCMS.countryrate.elements.map((obj) => ({
    title: obj.title || '',
    rates: obj.rates.map((e) => ({ title: e.title || '', value: e.value || '' })),
  }));
